export default {
  ALL_APPLIED_LIST: 'all-applied-list',
  ALL_POSTED_JOB_LIST: 'all-posted-job-list',
} as const;
